export default __webpack_public_path__ + "static/media/register.a50aafd0.png";